import { useState } from "react";
import '../../styles/EventsStyles/IntroVideo.css';
import posterImg from '../../assets/images/profile/Tebogo_Kole-pic.jpg';
import { INTRO_VIDEO_EMBED_URL } from "../../webinars/config";

// Tebogo's welcome video. Shows a poster until the embed URL is set in webinars/config.ts,
// then loads the YouTube/Vimeo player only when the visitor presses play.
export default function IntroVideo() {
  const [playing, setPlaying] = useState(false);
  const hasVideo = INTRO_VIDEO_EMBED_URL !== "";

  if (playing && hasVideo) {
    const src = `${INTRO_VIDEO_EMBED_URL}${INTRO_VIDEO_EMBED_URL.includes("?") ? "&" : "?"}autoplay=1`;
    return (
      <div className="ev-video">
        <iframe
          src={src}
          title="A welcome from Tebogo Kole"
          allow="autoplay; encrypted-media; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className="ev-video">
      <img src={posterImg} alt="" className="ev-video-poster" />
      <div className="ev-video-shade" />
      {hasVideo ? (
        <button type="button" className="ev-video-play" onClick={() => setPlaying(true)} aria-label="Play the welcome video from Tebogo Kole">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 4.5v15l13-7.5z" /></svg>
        </button>
      ) : (
        <span className="ev-video-soon">Video coming soon</span>
      )}
      <div className="ev-video-caption">
        <small>Introductory video</small>
        <strong>A welcome from Tebogo Kole</strong>
      </div>
    </div>
  );
}
